import ModalPui from "components/modal/ModalBookingSuccess";
import EventEnd1 from "pages/EventEnd1";
import EventEnd2 from "pages/EventEnd2";
import EventEnd3 from "pages/EventEnd3";
import BookingTime from "pages/register/BookingTime";
import Conclustion from "pages/register/Conclustion";
import DoctorSelect from "pages/register/DoctorSelect";
import EventPolicy from "pages/register/EventPolicy";
import EventPolicy2 from "pages/register/EventPolicy2";
import HandlePage from "pages/register/HandlePage";
import MomDetail from "pages/register/MomDetail";
import RegisterPolicy from "pages/register/RegisterPolicy";
import BnaProgram from "pages/register/BnaProgram";
import BnaProgramRecieved from "pages/register/BnaProgramRecieved";
import BnaProgramSuccess from "pages/register/BnaProgramSuccess";
import React, {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";



const appRouter = (props) => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DoctorSelect/>} />
        <Route path="/mom-detail" element={<MomDetail/>} />
        <Route path="/doctor-select" element={<DoctorSelect/>} />
        <Route path="/booking-time" element={<BookingTime/>} />
        <Route path="/conclustion" element={<Conclustion/>} />
        <Route path="/register-policy" element={<RegisterPolicy/>} />
        <Route path="/modal" element={ <ModalPui/>} />
        <Route path="/handle-page" element={ <HandlePage/>} />
        <Route path="/terms-and-conditions" element={ <EventPolicy/>} />
        <Route path="/event-end-1" element={ <EventEnd1/>} />
        <Route path="/event-end-2" element={ <EventEnd2/>} />
        <Route path="/event-end-3" element={ <EventEnd3/>} />
        <Route path="/terms-and-conditions-2" element={ <EventPolicy2/>} />
        <Route path="/bna-program" element={ <BnaProgram/>} />
        <Route path="/bna-program-recieved" element={ <BnaProgramRecieved/>} />
        <Route path="/bna-program-success" element={ <BnaProgramSuccess/>} />
      </Routes>
    </Router>
  );
};

export default appRouter;